import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type IModes = "dark" | "light";

interface IUSER {
    name: string;
    email: string;
    phoneNumber: string;
}

interface IRoot {
    user?: IUSER,
    themeMode?: IModes,
}

const initialState: IRoot = {
    user: {
        name: "",
        email: "",
        phoneNumber: "",
    },
    themeMode: "light",
};

const slice = createSlice({
    name: "persistStore",
    initialState,
    reducers: {
        setUser(state, action) {
            state.user = action.payload;
        },
        setThemeMode(state, action: PayloadAction<IModes>) {
            state.themeMode = action.payload;
        },
    },
});

export const PersistStoreActions = slice.actions;

export const reducer = slice.reducer;
export default slice;
